import LocalImages from "assets/images/local-images";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import { FC, ReactNode } from "react";
import { Link, Path } from "react-router-dom";

import LinkContent from "./styles/LinkContent.styled";
import StyledLocalLink from "./styles/StyledLocalLink.styled";

interface LocalLinkProps {
  to: string | Partial<Path>;
  search?: string;
  children: ReactNode;
  backLink?: boolean;
  state?: any;
}

const LocalLink: FC<LocalLinkProps> = ({ children, backLink, to, state }) => {
  return (
    <StyledLocalLink>
      <Link to={to} state={state}>
        <LinkContent>
          {backLink && (
            <img
              className="back-chevron"
              alt="back arrow"
              src={LocalImages.shared.images.icons.chevron.right}
            />
          )}
          <ButtonTitle>{children}</ButtonTitle>
          {!backLink && (
            <img
              className="forward-chevron"
              alt="forward arrow"
              src={LocalImages.shared.images.icons.chevron.right}
            />
          )}
        </LinkContent>
      </Link>
    </StyledLocalLink>
  );
};

export default LocalLink;
